import React, { useEffect, useState } from 'react';
import { getMatchedMonth, isCurrentMonth, isPartialMatch } from '../../../utils/helpers';
import { Placeholder } from '../../commons/components';
import { getDate, getDay, getDaysInMonth } from 'date-fns';

const integerMetricsArray = [
	'registered_users',
	'activeUsers',
	'total_users_played_content',
	'total_mins',
	'total_users_rated_content',
	'total_users_favorite_the_content',
	'total_users_syncing_steps',
	'personal_coaching_bookings_completed',
	'personal_coaching_bookings',
	'total_users_taking_waterintake',
	'total_water_intake',
	'total_reward_points_earned',
  'total_reward_points_redeemed',
	'total_users_earned_rewards',
	'total_users_redeemed_rewards',
	'total_push_sent',
	'total_challenges_launched',
	'total_challenges_joined',
	'total_challenges_participated',
	'programs_joined',
	'programs_completed',
	'audio_books_redeemed',
  'total_meal_images_uploaded',
  'total_meals_added',
  'total_ai_messages',
  'unique_nutrition_users',
];

const TableRowComponent = ({
  payload,
  showQuarterly = false,
  quarters = [],
  months = [],
  title,
  data = {},
  field = '',
  startDate,
  endDate,
  divisor,
  showPercentage = false,
  clickable = false,
  onClick = () => {},
  getPercentageOrAvg = () => {},
}) => {
  const [cellValues, setCellValues] = useState([]);

  const navigateToDetails = () => {
    if (!clickable) {
      return;
    }
    onClick(field);
  };

  useEffect(() => {
    if (!months.length) {
      return;
    }
    const values = months.map((month) =>
      !showPercentage ? getCellValue(month, field, divisor) : getPercentageOrAvg(month)
    );
    setCellValues(values);
  }, [months]);

  const getCellValue = (month, fieldName, divisorValue) => {
    if (!data.data) {
      return 0;
    }
    const matchedMonth = getMatchedMonth(data.data, month, startDate, endDate);
    if (matchedMonth) {
      if (divisorValue) {
        return Number(data.data[matchedMonth]?.[fieldName] / divisorValue).toFixed(2);
      }
      return Number(data.data[matchedMonth]?.[fieldName] || 0);
    }
    return 0;
  };

  const getQuarterValue = (quarter, fieldName, divisorValue) => {
    if (showPercentage) {
      return getPercentageOrAvg(quarter.endDate, quarter, true);
    }
    if (!data.data) {
      return 0;
    }
    if (fieldName === 'registered_users') {
      return getCellValue(quarter.endDate, fieldName, divisorValue);
    }
    const value =
      Object.values(data.data).find((item) => item.quarter === quarter.quarterNo)?.[fieldName] ?? 0;
    if (divisorValue) {
      return Number(value / divisorValue).toFixed(2);
    }
    return value;
  };

  const showLoaderForMonth = (month, cellValue) => {
    if (
      payload &&
      (new Date(month) >= new Date(payload.startDate) &&
      new Date(month) <= new Date(payload.endDate)) ||
      isPartialMatch(month, payload.endDate)
    ) {
      return true;
    }
    return false;
  };

  const getProjectedLastMonthValue = (month, cellValue) => {
    if (field === 'registered_users') {
      return '-';
    }
    /**
    const newArray = cellValues.slice(0, -1);
    const lastThreeElements = newArray.slice(-3);
    const sumOfLastThree = lastThreeElements.reduce((acc, currentValue) => acc + Number(currentValue), 0);
    const projectedValue = sumOfLastThree / lastThreeElements.length;

    if (isNaN(projectedValue)) {
      return '-';
    }
    if (integerMetricsArray.includes(field)) {
      return Number(Math.round(projectedValue)).toLocaleString('en-US');
    }
    return Number(projectedValue.toFixed(2));
    */
    let sum = 0;
    let count = 0;
    const newArray = cellValues.slice(-7, -1);
    for (let i = 1; i < newArray.length; i++) {
      const previousValue = Number(newArray[i - 1]) || 0;
      const currentValue = Number(newArray[i]) || 0;
      const difference = currentValue - previousValue;
      sum += difference;
      count++;
    }
    // Calculate the average monthly increase
    const averageMonthlyIncrease = sum / count;
    const valueInLastMonth = Number(newArray[newArray.length - 1]);
    const projectedValueInCurrentMonth = valueInLastMonth + averageMonthlyIncrease;

    if (isNaN(projectedValueInCurrentMonth)) {
      return '-';
    }
    if (integerMetricsArray.includes(field)) {
      return Number(Math.round(projectedValueInCurrentMonth)).toLocaleString('en-US');
    }
    return Number(projectedValueInCurrentMonth).toFixed(2);
  }

  return (
    <>
      <tr>
        <th
          scope='row'
          className={`first-column w-25${clickable ? ' link-style' : ''}`}
          onClick={navigateToDetails}
        >
          {title}
        </th>
        {showQuarterly &&
          quarters.map((item) => (
            <td key={item.quarter} style={{ textAlign: 'center' }}>
              {data.loading ? (
                <Placeholder width='90%' height={20} />
              ) : (
                getQuarterValue(item, field, divisor)
              )}
            </td>
          ))}
        {!showQuarterly &&
          cellValues.map((value, index) => (
            <React.Fragment key={`${months[index]}-${index}`}>
              <td style={{ textAlign: 'center' }}>
                {(data.loading || value === 'loading') && showLoaderForMonth(months[index], value) ? (
                  <Placeholder width='90%' height={20} />
                ) : (
                  value?.toLocaleString('en-US')
                )}
              </td>
              {index === cellValues.length - 1 && isCurrentMonth(months[index]) && months.length > 6 && (
                <>
                  <td className='last-column' style={{ textAlign: 'center' }}>{getProjectedLastMonthValue(months[index], value)}</td>
                </>
              )}
            </React.Fragment>
          ))}
      </tr>
    </>
  );
};

export default TableRowComponent;
